import React, { createContext, useState } from "react";

interface ThemeContextType {
  getTicket?: [
    string | undefined,
    React.Dispatch<React.SetStateAction<string | undefined>>
  ];
  getPurchaseList?: [
    string | undefined,
    React.Dispatch<React.SetStateAction<string | undefined>>
  ];
  payjpData?: [
    object | undefined,
    React.Dispatch<React.SetStateAction<object | undefined>>
  ];
  getMenuListData?: [
    string | undefined,
    React.Dispatch<React.SetStateAction<string | undefined>>
  ];
  getSaleTickets?: [
    string | undefined,
    React.Dispatch<React.SetStateAction<string | undefined>>
  ];
  getReservationSchedule?: [
    object | undefined,
    React.Dispatch<React.SetStateAction<object | undefined>>
  ];
  getSingleTicket?: [
    object | undefined,
    React.Dispatch<React.SetStateAction<object | undefined>>
  ];
  clearThemeContext?: any;
}

const initialContextValue: ThemeContextType = {};

const ThemeContext = createContext<ThemeContextType | any>(initialContextValue);

const ThemeContextProvider = ({ children }) => {
  const [ticket, setTicket] = useState<string | undefined>(undefined);
  const [purchaseList, setPurchaseList] = useState<string | undefined>(
    undefined
  );
  const [reservationSchedule, setReservationSchedule] = useState<
    object | undefined
  >(undefined);
  const [menuListData, setMenuListData] = useState<string | undefined>(
    undefined
  );
  const [saleTickets, setSaleTickets] = useState<string | undefined>(undefined);
  const [payjpData, setPayjpData] = useState<object | undefined>({
    changes: "",
  });
  const [singleTicket, setSingleTicket] = useState<object | undefined>(
    undefined
  );
  function clearThemeContext() {
    setTicket(undefined);
    setPurchaseList(undefined);
    setMenuListData(undefined);
    setReservationSchedule(undefined);
    setSaleTickets(undefined);
    setSingleTicket(undefined);
  }
  const contextValue: ThemeContextType = {
    getTicket: [ticket, setTicket],
    getPurchaseList: [purchaseList, setPurchaseList],
    payjpData: [payjpData, setPayjpData],
    getMenuListData: [menuListData, setMenuListData],
    getReservationSchedule: [reservationSchedule, setReservationSchedule],
    getSaleTickets: [saleTickets, setSaleTickets],
    getSingleTicket: [singleTicket, setSingleTicket],
    clearThemeContext: clearThemeContext,
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContextProvider, ThemeContext };
